import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { successNotification, errorNotification, warningNotification } from '../../notification';
import { FormFieldDrop, FormFieldGeneric } from '../../formField';
import FormRow from '../../formRow';
import Popup from '../layout';
import * as relationshipService from '../../../services/relationship';
import { useForms } from '../../../hooks';

const initialForm = {
  Nome: ''
};

const PopUpRelationshipStatus = ({
  visible,
  setVisible,
  reloadRelationshipStatuses,
  isEdit,
  entity
}) => {
  const [form, updateForm, setForm] = useForms(initialForm);

  const createRelationshipStatus = async (body) => {
    const response = await relationshipService.createRelationshipStatus(body);
    const { data } = response;
    if (response.status === 200) {
      body = {
        ...body,
        Id: data,
        Editavel: true
      };
      successNotification('Situação criada com sucesso!');
      await reloadRelationshipStatuses(body);
    } else if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
    else errorNotification('Houve um erro ao tentar atualizar uma situação.');
  };

  const editRelationshipStatus = async (body) => {
    const response = await relationshipService.updateRelationshipStatus(body, body.Id);
    if (response.status === 200) {
      body = {
        Id: body.Id,
        Editavel: true,
        ...body
      };
      successNotification('Situação atualizada com sucesso!');
      await reloadRelationshipStatuses(body);
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
      else errorNotification('Houve um erro ao tentar atualizar uma situação.');
    }
  };

  const excludeRelationshipStatus = async () => {
    const response = await relationshipService.excludeRelationshipStatus(entity.Id);
    if (response.status === 200) {
      successNotification('Situação excluída com sucesso!');
      await reloadRelationshipStatuses(null);
    } else {
      const { data } = response;
      if (data.MensagemUsuario !== undefined) warningNotification(data.MensagemUsuario);
      else errorNotification('Houve um erro ao tentar excluir uma situação.');
    }
  };

  const submitHandle = () => {
    const body = {
      Id: entity?.Id,
      ...form
    };

    return isEdit ? editRelationshipStatus(body) : createRelationshipStatus(body);
  };

  useEffect(() => {
    setForm(entity || initialForm);
  }, [entity, visible]);

  return (
    <Popup
      visible={visible}
      setVisible={setVisible}
      title="Situação"
      confirmText="Salvar"
      cancelText="Cancelar"
      haveExclude={isEdit}
      onConfirm={submitHandle}
      onDelete={excludeRelationshipStatus}
    >
      <FormRow>
        <FormFieldGeneric
          titleLabel="Nome"
          classNameWrapper="fill-100-field-tooltip"
          name="Nome"
          onChangeValue={updateForm}
          valueInput={form.Nome}
          required
        />
      </FormRow>
    </Popup>
  );
};

PopUpRelationshipStatus.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  reloadRelationshipStatuses: PropTypes.func.isRequired
};

export default PopUpRelationshipStatus;
